<template>
  <div class="visor w-100 p2">
    <l-map class="mapa" ref="mapa"
           :zoom="initialZoom"
           :options="mapOptions"
           :center="center"
           @update:zoom="zoomUpdated"
           @update:center="centerUpdated"
           @update:bounds="boundsUpdated"
           @ready="raton"
    >
      <Cartografia></Cartografia>

      <Refugios v-if="refugiosJson" :geojson="refugiosJson"
                ref="refugios" :visibles="refugios" @refugioSeleccionado="refugioSeleccionado"
                @refugiosCargados="refugiosCargados"></Refugios>

      <Parkings v-if="parkingsJson" :geojson="parkingsJson" ref="parkings">

      </Parkings>
      <Rutas v-if="rutasJson" :geojson="rutasJson" :visibles="rutas" ref="rutas"
             @rutaSeleccionada="rutaSeleccionada"   @centrar="cargado"></Rutas>

      <l-control-scale position="bottomleft" :metric="true"></l-control-scale>

      <l-control position="bottomright">
        <FichaRefugio v-if="refugioPulsado" @cerrarFicha="cerrarRefugio"
                      :seleccion="refugioPulsado"
                      :texto="texto.mapa.refugio">

        </FichaRefugio>
        <FichaRuta v-if="rutaPulsada" :seleccion="rutaPulsada"
                   @cerrarFicha="cerrarRuta"
                   :texto="texto.mapa.ruta">
        </FichaRuta>
      </l-control>

    </l-map>
  </div>
</template>

<script>
import {latLng} from 'leaflet';
import {LMap, LControlScale, LControl} from 'vue2-leaflet';
import {refugiosService, rutasService} from "@/services";

import Cartografia from "@/components/Cartografia";
import Refugios from "@/components/Refugios";
import Rutas from "@/components/Rutas";
import FichaRefugio from "@/components/FichaRefugio";
import FichaRuta from "@/components/FichaRuta";
import Parkings from "./components/Parkings";

export default {
  name: "Mapa",
  props: ['idioma', 'refugios', 'rutas'],
  data() {
    return {
      initialZoom: 8,
      center: latLng(42.759519, 0.190770),
      mapOptions: {
        zoomSnap: 0.5,
        zoomDelta: 0.5,
        minZoom: 8,
        maxZoom: 18
      },
      currentZoom: 8,
      currentCenter: latLng(42.759519, 0.190770),
      currentBounds: null,
      currentMouse: '',
      esMovil: false,
      refugiosJson: null,
      parkingsJson: null,
      rutasJson: null,
      refugioPulsado: null,
      rutaPulsada: null,
      texto: null,
    }
  },
  async created() {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      this.esMovil = true
    }
    refugiosService.all().then( data => {
      this.refugiosJson = data;
    })
    refugiosService.parkings().then(data => {
      this.parkingsJson = data;
    });
    rutasService.all(this.idioma).then( data => {
      this.rutasJson = data;
    })

    const raw = await fetch(`https://api.entrepyr.eu/widgetLanguage/${this.idioma}/routebuilder.json`)
    const data = await raw.json()
    this.texto = data.data

  },
  mounted() {
    this.boundsUpdated(this.$refs.mapa.mapObject.getBounds())
  },
  computed: {
  },
  methods: {
    refugiosCargados() {
      this.refugios.forEach(refugio => {
        const ref = this.$refs.refugios.$refs.refugios.mapObject.getLayers().find( l =>
          parseInt(l.feature.properties.id) === parseInt(refugio)
        );
        ref.feature.properties.parkings.forEach( parking => {
          this.$refs.parkings.$refs.parkings.mapObject.eachLayer(l => {
            if(parseInt(l.feature.properties.id) === parseInt(parking)) {
              l.setOpacity(1);
            }
          })
        });
      });
      /*this.$refs.parkings.$refs.parkings.mapObject.eachLayer(l => {
        console.log(l.feature.properties)
      })*/
    },
    cargado(data) {
      this.$refs.mapa.mapObject.fitBounds(data.bounds)
    },
    refugioSeleccionado(data) {
      this.cerrarRuta()
      this.refugioPulsado = data.refugio
    },
    rutaSeleccionada(data) {
      this.cerrarRefugio()
      this.rutaPulsada = data.ruta
    },
    cerrarRefugio() {
      this.refugioPulsado = null
    },
    cerrarRuta() {
      this.rutaPulsada = null
    },
    zoomUpdated(zoom) {
      this.currentZoom = zoom
    },
    centerUpdated(center) {
      this.currentCenter = `${center.lat.toFixed(4)}, ${center.lng.toFixed(4)}`
    },
    boundsUpdated(bounds) {
      const ne = bounds.getNorthEast()
      const sw = bounds.getSouthWest()
      this.currentBounds = `NE: ${ne.lat.toFixed(4)}, ${ne.lng.toFixed(4)}
      - SW: ${sw.lat.toFixed(4)}, ${sw.lng.toFixed(4)}`
    },
    raton(map) {
      map.on('mousemove', (mouse) => {
        this.currentMouse = `${mouse.latlng.lat.toFixed(4)}, ${mouse.latlng.lng.toFixed(4)}`
      })
    },
  },
  components: {
    FichaRuta,
    FichaRefugio,
    LMap,
    LControlScale,
    LControl,
    Cartografia,
    Rutas,
    Refugios,
    Parkings

  }
}
</script>

<style scoped>
.visor {
  height: 450px;
}
.mapa {
  max-height: 500px;
  width: 100%;
  margin: 0 auto;
  border-radius: 20px;
}
ul {
  font-size: 18px;
  font-weight: 700;
  color: white;
  display: flex;
  flex-direction: row;
}
ul li {
  margin: 1rem;
}
</style>